export const PagesThatDontNeedIdleTracking = [
  '/login',
  '/create-account',
  '/login-help',
  '/login-help/forgotPassword',
  '/email-sent',
  '/reminder-sent',
  '/mypolicy',
  '/guestVerify',
  '/unauthorized',
  '/404',
  '/500',
  '/technology-agreement',
  '/maintenance',
  '/tfcp',
  '/tccp',
  '/tupss',
  '/prospect',
  '/prospect-portal',
  '/ssp',
  '/unishippers',
  '/ajg',
  '/inxpress',
  '/pirate-ship',
  '/happy-returns'
]

export const ALLOWED_DOC_TYPES = ['jpg','png','jpeg','svg','webp','pdf','doc','docx','xls','xlsx','csv','msg','txt','heic'];